/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { AaiInfo } from '../../models/AaiInfo';
import { Node } from '../../../core/models/Node';
import { Info } from '../../../core/models/common/Info';

/**
 * Constructor.
 * @param {Node} parent
 * @class
 * @extends AaiInfo
 * @author eric.wittmann@gmail.com
 */
export class Aai20Info extends AaiInfo {
    public constructor(parent? : any) {
        if(((parent != null && parent instanceof <any>Node) || parent === null)) {
            let __args = arguments;
            super(parent);
        } else if(parent === undefined) {
            let __args = arguments;
            super();
        } else throw new Error('invalid overload');
    }

    /**
     * @see Info#createContact()
     * @return {Aai20Contact}
     */
    public createContact() : Aai20Contact {
        return new Aai20Contact(this);
    }

    /**
     * @see Info#createLicense()
     * @return {Aai20License}
     */
    public createLicense() : Aai20License {
        return new Aai20License(this);
    }
}
Aai20Info["__class"] = "io.apicurio.datamodels.asyncapi.v2.models.Aai20Info";
Aai20Info["__interfaces"] = ["io.apicurio.datamodels.core.models.IVisitable"];





import { Aai20License } from './Aai20License';


import { Aai20Contact } from './Aai20Contact';

